import React from 'react';
import { Switch } from 'react-router-dom';
import { PublicRoute } from '@marvelapp/ballpark-application';
import { NotFound } from './ErrorPages';
export function SwitchWithNotFound({ errorComponent = NotFound, children, }) {
    return (React.createElement(Switch, null,
        children,
        React.createElement(PublicRoute, { component: errorComponent })));
}
